import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
export { Elements } from "@stripe/react-stripe-js";
